// HomePage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "#ffffff" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "48px 20px" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div
            style={{
              width: 54,
              height: 54,
              borderRadius: "50%",
              background: "#eef2ff",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 14,
            }}
            aria-hidden="true"
          >
            <span style={{ fontSize: 22 }}>🎓</span>
          </div>

          <h1 style={{ margin: 0, fontSize: 40, fontWeight: 800, color: "#111827" }}>
            Articulate AI GradeFlow
          </h1>
          <div style={{ marginTop: 10, fontSize: 18, color: "#6b7280" }}>
            Automated Question Paper Grading System
          </div>
        </div>

        {/* Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 22,
          }}
        >
          {/* Teachers */}
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 16,
              background: "#ffffff",
              padding: 28,
              boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: "50%",
                  background: "#eef2ff",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
                aria-hidden="true"
              >
                <span style={{ fontSize: 22 }}>🎓</span>
              </div>

              <div style={{ fontSize: 28, fontWeight: 800, color: "#111827" }}>
                Teachers
              </div>

              <div style={{ marginTop: 10, color: "#6b7280", fontSize: 16 }}>
                Upload question papers and manage submissions
              </div>

              <button
                type="button"
                onClick={() => navigate("/teacher-login")}
                style={{
                  marginTop: 18,
                  width: "100%",
                  height: 46,
                  borderRadius: 10,
                  border: "1px solid #2563eb",
                  background: "#2563eb",
                  color: "#ffffff",
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Teacher Login
              </button>
            </div>
          </div>

          {/* Students */}
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 16,
              background: "#ffffff",
              padding: 28,
              boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: "50%",
                  background: "#ecfeff",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
                aria-hidden="true"
              >
                <span style={{ fontSize: 22 }}>👤</span>
              </div>

              <div style={{ fontSize: 28, fontWeight: 800, color: "#111827" }}>
                Students
              </div>

              <div style={{ marginTop: 10, color: "#6b7280", fontSize: 16 }}>
                Submit Work
              </div>

              <button
                type="button"
                onClick={() => navigate("/student-upload-pdf")}
                style={{
                  marginTop: 18,
                  width: "100%",
                  height: 46,
                  borderRadius: 10,
                  border: "1px solid #d1d5db",
                  background: "#ffffff",
                  color: "#111827",
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Composition/Situational Writing
              </button>

              <button
                type="button"
                onClick={() => navigate("/oral-exam-voice")}
                style={{
                  marginTop: 12,
                  width: "100%",
                  height: 46,
                  borderRadius: 10,
                  border: "1px solid #d1d5db",
                  background: "#ffffff",
                  color: "#111827",
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Oral Exam Practice
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 22,
            marginTop: 28,
          }}
        >
          <div>
            <div style={{ marginBottom: 10, color: "#111827", fontSize: 18, fontWeight: 800 }}>
              How to use the Compo Grader
            </div>
            <div style={{ position: "relative", paddingTop: "56.25%" }}>
              <iframe
                src="https://www.youtube-nocookie.com/embed/qNMez8-Fb9M"
                title="How to use the Compo Grader"
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </div>

          <div>
            <div style={{ marginBottom: 10, color: "#111827", fontSize: 18, fontWeight: 800 }}>
              Demonstration of the AI Oral Examiner
            </div>
            <div style={{ position: "relative", paddingTop: "56.25%" }}>
              <iframe
                src="https://www.youtube-nocookie.com/embed/mstomEUoFJQ"
                title="Demonstration of the AI Oral Examiner"
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </div>
        </div>
        <div style={{ marginTop: 16, textAlign: "center", color: "#4b5563", fontSize: 16 }}>
          Interested to sign up? Send enquiries to{" "}
          <a href="mailto:contact@articulate.com.sg" style={{ color: "#2563eb", fontWeight: 700 }}>
            contact@articulate.com.sg
          </a>
          .
        </div>

        {/* Responsive */}
        <style>{`
          @media (max-width: 900px) {
            div[style*="grid-template-columns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
          }
        `}</style>
      </div>
    </div>
  );
}
